<template>
  <div
    class="message-list-wrap"
    :class="{ mobile: mobile, smaller: !directchat }"
  >
    <div v-if="directchat" class="messages-and-person-info">
      <div class="chat-person-info">
        <div
          class="icon-name"
          @click="goToProfile"
          v-tooltip="'Go to profile.'"
        >
          <div class="go-back" v-if="mobile" @click.stop="goBack">
            <span class="material-icons">arrow_back_ios</span>
          </div>
          <div class="dm-icon-wrap">
            <div class="img-wrap">
              <img
                class="frame"
                :src="
                  imageBaseUrl +
                  'api/users/' +
                  'pictureframe?rol_id=' +
                  rolId +
                  '&type=circle' +
                  '&sid=' +
                  sid
                "
                alt=""
              />
              <img draggable="false" :src="directchat.imageURL" />
            </div>
            <div class="green-dot" v-if="directchat.online"></div>
          </div>
          <div class="name-title">
            <span>{{ directchat.name }} {{ directchat.lastname }}</span>
            <span>{{ directchat.title }}</span>
          </div>
        </div>
        <div
          v-if="checkPermissions(['user_report_user'])"
          class="see-profile-or-report"
        >
          <img @click.stop="reportProfile" :src="$images.reportIcon" />
        </div>
      </div>
      <transition name="chat-fade">
        <div
          class="scroll-to-bottom"
          v-if="hasNewMsg"
          @click="clickScrollToBottom()"
        >
          <span class="material-icons">keyboard_arrow_down</span>
        </div>
      </transition>
      <div class="chat-messages" @scroll.stop="handleScroll">
        <div class="loading-div">1</div>
        <div
          v-for="(msg, i) in messages.filter((item) => {
            if (item.content) return item;
          })"
          :key="msg.id"
          :ref="'msg' + msg.id"
          class="individual-message"
          :class="typeOfMsg(msg, i)"
        >
          <div class="img-wrap" v-if="shouldShowImage(msg, i)">
            <img
              :src="directchat.imageURL"
              draggable="false"
              @click="goToProfile(msg)"
            />
          </div>
          <span
            class="content"
            v-html="msg.content.replace(/</g, '<span><</span>')"
            v-linkified
            @mouseenter="setShowreport(msg, true)"
          ></span>
          <div
            class="report"
            v-if="senderNotMe(msg)"
            @mouseenter="setShowreport(msg, true)"
            @mouseleave="setShowreport(msg, false)"
          >
            <transition name="chat-fade">
              <img
                :src="$images.reportIcon"
                draggable="false"
                v-if="
                  msg.showReport && checkPermissions(['chat_report_message'])
                "
                @click="reportMsg(msg.id)"
              />
            </transition>
          </div>
          <span class="timestamp">{{ msg.timestamp }}</span>
        </div>
        <div class="padding-div">1</div>
      </div>
      <div v-if="checkPermissions(['chat_send_message'])" class="input-wrap">
        <custominput :block="sendMsgBlockTimer" v-on:send="handleSend" />
      </div>
    </div>
    <div class="choose-chat-wrap" v-else>
      <span v-html="$t('chat.chooseChat')"></span>
      <img :src="$images.chooseChat" />
    </div>
  </div>
</template>

<script>
import api from "../../api";
import custominput from "@/components/chat/Input.vue";
import messageMixin from "./messageMixin";
export default {
  data() {
    return {
      messages: [],
      currentLimit: 50,
      loadingNewMessages: false,
      refresTimer: null,
      hasNewMsg: false,
      topMsgId: null,
      sendMsgBlockTimer: 0,
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
    };
  },
  components: {
    custominput,
  },
  props: {
    directchat: {
      reqired: false,
    },
    orientation: Boolean,
    mobile: Boolean,
    rolId: Number,
  },
  watch: {
    directchat: {
      deep: true,
      immediate: false,
      handler() {
        this.init();
        this.currentLimit = 50;
      },
    },
  },
  mounted() {
    if (this.mobile)
      this.$nextTick(() => {
        this.init();
      });
  },
  beforeDestroy() {
    this.stopUpdate();
    this.currentLimit = 50;
  },
  computed: {
    sid() {
      return localStorage.getItem("sid");
    },
  },
  mixins: [messageMixin],
  methods: {
    goBack() {
      this.$emit("goback");
    },
    async handleSend(text) {
      const No_OF_SECONDS_FOR_BLOCK = 1;
      let obj = {
        text: text,
        usr_id: this.directchat.id,
      };
      if (obj.text && obj.usr_id) {
        try {
          this.sendMsgBlockTimer = No_OF_SECONDS_FOR_BLOCK;
          await api.sendMessage(obj);
        } catch (error) {
          this.handleError(error);
        }
        setTimeout(() => {
          this.sendMsgBlockTimer = 0;
        }, No_OF_SECONDS_FOR_BLOCK * 1000);
        this.init();
      }
    },
    handleScroll(evt) {
      let currentScrollH = evt.target.scrollTop + evt.target.offsetHeight;
      let maxScrollH = evt.target.scrollHeight;
      if (maxScrollH - currentScrollH > 100) {
        this.showScrollToBottomButton(true);
      }
      if (maxScrollH - currentScrollH === 0) {
        this.showScrollToBottomButton(false);
      }
      if (evt.target.scrollTop <= 0) {
        this.fetchNewMessages();
      }
    },
    async fetchNewMessages() {
      if (this.loadingNewMessages || !this.directchat) return;
      this.loadingNewMessages = true;
      this.currentLimit += 50;

      try {
        let obj = {
          usr_id: this.directchat.id,
          limit: this.currentLimit,
        };
        let res = await api.getMessages(obj);
        this.trasnformAPIResponseForAdditional(res.data.data);
      } catch (error) {
        this.handleError(error);
      }
      this.loadingNewMessages = false;
    },
    setShowreport(msg, bool) {
      if (msg.sender != this.getMyUsrId())
        this.$nextTick(() => {
          this.$set(msg, "showReport", bool);
        });
    },
    goToProfile() {
      let ext =
        this.directchat.name +
        "-" +
        this.directchat.lastname +
        "-" +
        this.directchat.id;
      this.$router.push("/profile/" + ext.toLowerCase());
      if (this.mobile) this.closeChat();
    },
    closeChat() {
      try {
        this.setChat(false);
      } catch (error) {
        this.handleError(error);
      }
      // store.dispatch("setChat", false);
    },
    reportProfile() {
      let msg = {
        message: false,
        id: this.directchat.id,
      };
      this.$emit("report", msg);
    },
    shouldShowImage(msg, i) {
      let messages = this.messages;
      if (
        msg.sender === this.directchat.id &&
        (messages[i + 1] === undefined ||
          messages[i + 1] === null ||
          messages[i + 1].sender !== msg.sender)
      )
        return true;
    },
    async init() {
      try {
        let obj = {
          usr_id: this.directchat.id,
          limit: this.currentLimit,
        };
        let res = await api.getMessages(obj);
        this.trasnformInit(res.data.data);
      } catch (error) {
        this.handleError(error);
      }
      if (this.refresTimer) {
        clearTimeout(this.refresTimer);
        this.refresTimer = null;
      }
      this.refresTimer = setInterval(() => {
        this.refreshMessages();
      }, 3000);
    },
    trasnformInit(arr) {
      let newArr = [];
      for (let index = 0; index < arr.length; index++) {
        const el = arr[index];
        let formatData = {
          id: el.msg_id,
          content: el.msg_text,
          sender: el.usr_id_sender,
          timestamp: this.formatTime(el.msg_sent),
          read: el.msg_read,
        };
        newArr.push(formatData);
      }
      this.messages = newArr;
      this.topMsgId = this.messages[0] ? this.messages[0].id : null;
      this.scrollToLast();
    },
    async refreshMessages() {
      try {
        let obj = {
          usr_id: this.directchat.id,
          limit: this.currentLimit,
        };
        let res = await api.getMessages(obj);
        this.trasnformRefresh(res.data.data);
      } catch (error) {
        this.handleError(error);
      }
    },
    trasnformRefresh(arr) {
      let newArr = [];
      for (let index = 0; index < arr.length; index++) {
        const el = arr[index];
        let formatData = {
          id: el.msg_id,
          content: el.msg_text,
          sender: el.usr_id_sender,
          timestamp: this.formatTime(el.msg_sent),
          read: el.msg_read,
        };
        newArr.push(formatData);
      }
      if (newArr.length == 0) return;
      let code = this.arraysAreSame(newArr, this.messages);
      if (code == 2 || code == 1) {
        this.messages = newArr;
        this.topMsgId = this.messages[0].id;
        this.showScrollToBottomButton(true);
        this.scrollToLast();
      }
    },
    trasnformAPIResponseForAdditional(arr) {
      let newMessages = [];
      for (let index = 0; index < arr.length; index++) {
        const el = arr[index];
        let formatData = {
          id: el.msg_id,
          content: el.msg_text,
          sender: el.usr_id_sender,
          timestamp: this.formatTime(el.msg_sent),
          read: el.msg_read,
        };
        newMessages.push(formatData);
      }
      if (newMessages.length == 0) return;
      let code = this.arraysAreSame(this.messages, newMessages);
      switch (code) {
        case 1:
        case 3:
          this.messages = newMessages;
          this.scrollToRef();
          this.topMsgId = this.messages[0].id;
          this.showScrollToBottomButton(true);
          break;
        case 2:
          this.messages = newMessages;
          this.scrollToRef();
          this.topMsgId = this.messages[0].id;
          this.showScrollToBottomButton(true);
          break;
        default:
          this.currentLimit -= 50;
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@mixin flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.message-list-wrap {
  position: relative;
  height: calc(100% - 10px);
  width: calc(50% - 20px);
  padding: 10px 20px 00px 0;
  @include flex-center;
  &.smaller.mobile {
    max-height: 50%;
    height: 100%;
  }
  &.mobile {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-right: 0;
    .choose-chat-wrap {
      @include flex-center;
      padding: 0 15px;
      height: calc(100% - 30px);
      flex-direction: column;
      max-height: 100%;
      span {
        margin-bottom: 20px;
        font-size: 18px;
        text-align: center;
        font-weight: 300;
        max-height: 20%;
      }
      img {
        max-height: 80%;
      }
    }
    .chat-person-info {
      padding-right: 10px;
    }
    .chat-messages {
      .img-wrap {
        left: -32px;
        cursor: pointer;
        .frame {
          position: absolute;
        }
      }
    }
  }
}

.messages-and-person-info {
  position: relative;
  width: 100%;
  height: 100%;
}

.chat-person-info {
  padding-left: 20px;
  @include flex-start();
  .icon-name {
    cursor: pointer;
    width: calc(100% - 80px);
    @include flex-center;
    .dm-icon-wrap {
      @include flex-center;
      width: 80px;
      height: 80px;
      position: relative;
      .img-wrap {
        @include flex-center;
        position: relative;
        width: 55px;
        height: 55px;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
        border: 0.5px rgba(0, 0, 0, 0.118) solid;
        img {
          height: 100%;
          max-width: none;
        }
        .frame {
          position: absolute;
        }
      }
      .green-dot {
        position: absolute;
        width: 8px;
        height: 8px;
        left: 55px;
        top: 55px;
        border-radius: 50%;
        background-color: #69d200;
        z-index: 2;
      }
    }
    .name-title {
      @include flex-start;
      align-items: flex-start;
      flex-direction: column;
      width: calc(100% - 80px);
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 20px;
        max-height: 20px;
        max-width: 100%;
      }
      span:first-child {
        font-weight: 700;
      }
    }
  }
  .see-profile-or-report {
    min-width: 70px;
    @include flex-center();
    img:first-child {
      margin-right: 20px;
    }
    img:hover {
      cursor: pointer;
    }
    img {
      width: 25px;
      height: 25px;
    }
  }
}

.input-wrap {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 65px;
  background-color: white;
  user-select: none;
}
.scroll-to-bottom {
  @include flex-center();
  z-index: 4;
  position: absolute;
  bottom: 70px;
  right: 15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid rgb(182, 182, 182);
  background: rgba(255, 255, 255, 0.66);
}
.chat-messages {
  position: relative;
  box-sizing: border-box;
  padding-left: 20px;
  height: calc(100% - 150px);
  width: calc(100%);
  overflow-y: scroll;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .loading-div {
    color: transparent;
    width: 100%;
    height: 40px;
    @include flex-center();
  }
  .padding-div {
    color: transparent;
    line-height: 20px;
    height: 80px;
    width: 100%;
    // @include flex-center();
  }
  .individual-message {
    position: relative;
    padding: 10px;
    width: 75%;
    margin: 10px 0;
    .content {
      position: relative;
      z-index: 2;
      word-wrap: break-word; // very important do not del
      box-sizing: border-box;
      text-align: left;
      padding: 0 10px;
      width: 100%;
      display: block;
    }
    .report {
      @include flex-end();
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0, -50%);
      width: calc(100% + 30px);
      height: 100%;
      img {
        cursor: pointer;
        position: relative;
        width: 30px;
        height: 30px;
        right: 10px;
        left: auto;
      }
    }
    .timestamp {
      color: black;
      position: absolute;
      right: 10px;
      bottom: -13px;
      opacity: 0.8;
      font-size: 11px;
    }
  }
  .img-wrap {
    @include flex-center();
    height: 25px;
    width: 25px;
    position: absolute;
    border-radius: 50%;
    bottom: 0;
    left: -35px;
    cursor: pointer;
    overflow: hidden;
    border: 0.5px rgba(0, 0, 0, 0.118) solid;
    img {
      height: 100%;
      max-width: none;
    }
  }
  .my-msg {
    margin-right: 10px;
    align-self: flex-end;
    background-color: rgb(115, 50, 158);
    color: white;
  }
  .their-msg {
    margin-left: 15px;
    align-self: flex-start;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.171);
  }
  .top-round {
    border-radius: 20px 20px 0 0;
  }
  .bot-round.my-msg {
    border-radius: 0 0 0 20px;
  }
  .bot-round.their-msg {
    border-radius: 0 0 20px 0;
  }
  .bot-round.top-round.my-msg {
    border-radius: 20px 20px 0 20px;
  }
  .bot-round.top-round.their-msg {
    border-radius: 20px 20px 20px 0;
  }
}

.choose-chat-wrap {
  @include flex-center;
  flex-direction: column;
  span {
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
    font-weight: 300;
  }
}
</style>